/**
 * Route-level error boundary. Shows the request id so support can find the
 * correlated server log — never the underlying error text, which may name
 * internals the user has no business seeing.
 */
import { isRouteErrorResponse, useRouteError } from 'react-router';
import { ApiError } from '../api.ts';

export default function ErrorScreen() {
  const error = useRouteError();

  const message = isRouteErrorResponse(error)
    ? `${error.status} ${error.statusText}`
    : error instanceof ApiError
      ? error.message
      : '予期しないエラーが発生しました。';

  return (
    <div className="login">
      <div className="card" role="alert">
        <h1 className="card__title">エラー</h1>
        <p>{message}</p>
        <a className="btn" href="/">
          ダッシュボードに戻る
        </a>
      </div>
    </div>
  );
}
